import { Steps, Button } from 'antd';
import styled from 'styled-components';

export const StyledSteps = styled(Steps)`
  margin-bottom: ${({ theme }) => theme.spacing.space_4};
`;

export const SaveContainer = styled.div`
  padding: ${({ theme }) => theme.spacing.space_5} 0;
  text-align: center;
`;

export const SaveTitle = styled.h4`
  margin-bottom: ${({ theme }) => theme.spacing.space_4};
`;

export const ReadyText = styled.p`
  margin-bottom: ${({ theme }) => theme.spacing.space_5};
`;

export const DescriptionText = styled.p`
  margin-bottom: ${({ theme }) => theme.spacing.space_5};
  color: ${({ theme }) => theme.palette.neutrals.storm};
  font-size: ${({ theme }) => theme.font.size.small};
`;

export const LoadingContainer = styled.div`
  padding: ${({ theme }) => theme.spacing.space_5} 0;
`;

export const LoadingIcon = styled.div`
  font-size: ${({ theme }) => theme.font.size.large};
  margin-bottom: ${({ theme }) => theme.spacing.space_4};
`;

export const ResultContainer = styled.div`
  padding: ${({ theme }) => theme.spacing.space_5} 0;
`;

export const SuccessText = styled.p`
  color: ${({ theme }) => theme.palette.status.good};
  font-size: ${({ theme }) => theme.font.size.medium};
  margin-bottom: ${({ theme }) => theme.spacing.space_4};
`;

export const ErrorText = styled.p`
  color: ${({ theme }) => theme.palette.status.bad};
  font-size: ${({ theme }) => theme.font.size.medium};
  margin-bottom: ${({ theme }) => theme.spacing.space_4};
`;

export const UpdatedCountText = styled.p`
  margin-bottom: ${({ theme }) => theme.spacing.space_2};
`;

export const WarningText = styled.p`
  color: ${({ theme }) => theme.palette.yellows.summer};
  font-size: ${({ theme }) => theme.font.size.small};
`;

export const ErrorDetailsText = styled.p`
  color: ${({ theme }) => theme.palette.neutrals.storm};
  font-size: ${({ theme }) => theme.font.size.small};
`;

export const CloseButton = styled(Button)`
  margin-top: ${({ theme }) => theme.spacing.space_4};
`;
